// Efecto "titilante" dorado (prende/apaga) reutilizable: resalta una columna/card a la que se salta
// (p. ej. al venir de la vista de mes o de un deep-link). Antes vivía inline en CondensedWeekAgenda.
// Regla de estilo única para mantener el mismo efecto en agenda (cliente/entrenador/admin) y en las
// cards de "Sesiones" de disponibilidad. Solo anima `background-color` (barato, sin reflow).
// Se usa la sintaxis `@keyframes` dentro de `sx` (emotion genera un nombre único) para no depender
// de helpers externos.

// 3 ciclos de ~0.7s ≈ 2.1s. Sincronizar el timeout que limpia el highlight con ~2400ms.
export const GOLD_PULSE_DURATION_MS = 2400;

/**
 * Devuelve el `sx` del parpadeo dorado.
 *
 * @param  {Object}   theme   tema MUI (para `palette.gold.soft`, mode-aware).
 * @param  {Boolean}  active  si está activo el resaltado (al saltar a ese día/card).
 * @returns  {Object}  sx (vacío si no está activo).
 */
export const goldPulseSx = (theme, active) => {
  if (!active) return {};
  return {
    animation: 'otxGoldPulse 0.7s ease-in-out 3',
    willChange: 'background-color',
    '@keyframes otxGoldPulse': {
      '0%, 100%': { backgroundColor: 'transparent' },
      '50%': { backgroundColor: theme.palette.gold.soft }
    }
  };
};

export default goldPulseSx;
